export default __webpack_public_path__ + "static/media/Trash.db71491f.svg";